/**
 * PokemonGrid Component - Displays Pokemon cards in a single row
 */

import type { Pokemon } from '../types/pokemon';
import { PokemonCard } from './PokemonCard';

interface PokemonGridProps {
  pokemon: Pokemon[];
  loading: boolean;
  generation?: number;
}

export function PokemonGrid({ pokemon, loading, generation = 0 }: PokemonGridProps) {
  const showSkeletons = loading && pokemon.length === 0;

  if (showSkeletons) {
    return (
      <div className="flex gap-6 justify-center items-stretch">
        {[...Array(3)].map((_, i) => (
          <LoadingCard key={i} />
        ))}
      </div>
    );
  }

  return (
    <div className={`flex gap-6 justify-center items-stretch ${loading ? 'opacity-50 pointer-events-none' : ''}`}>
      {pokemon.map((poke, index) => (
        <PokemonCard
          key={`${poke.id}-${generation}-${index}`}
          pokemon={poke}
          index={index}
        />
      ))}
    </div>
  );
}

function LoadingCard() {
  return (
    <div className="pokemon-box p-5 flex flex-col items-center w-[340px] animate-pulse">
      <div className="w-12 h-5 bg-poke-red-dark rounded-full mb-2"></div>
      <div className="w-32 h-32 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl border-3 border-poke-blue-dark mb-3"></div>
      <div className="w-36 h-8 bg-gradient-to-r from-poke-blue to-poke-blue-dark rounded-lg mb-2 border-3 border-poke-blue-darker"></div>
      <div className="flex gap-2">
        <div className="w-16 h-6 bg-gray-400 rounded-lg border-2 border-gray-600"></div>
        <div className="w-16 h-6 bg-gray-400 rounded-lg border-2 border-gray-600"></div>
      </div>
    </div>
  );
}
